import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { Accordion, Button } from '@gemini/ui';
import { ExternalLinkIcon } from '@gemini/icons';
import BlockTitle from '@/components/structure/BlockTitle';
import Container from '@/components/structure/Container';
import { useTranslation } from '@/hooks/useTranslations';
import { redirectTo } from '@/helpers/goTo';
export const FrequentlyAskedQuestions = ({ name }) => {
    const { t } = useTranslation();
    const items = [...Array(6)].map((_, index) => {
        return {
            title: t(`fsrbo.generic.faq.list.item${index + 1}.title`),
            content: t(`fsrbo.generic.faq.list.item${index + 1}.text`),
        };
    });
    return (_jsxs(Container, { paddingVertical: {
            'breakpoint.base': 'spacing.32',
            'breakpoint.lg': 'spacing.80',
        }, children: [_jsx(Box, { textAlign: "center", children: _jsx(BlockTitle, { as: "h2", children: t('fsrbo.generic.faq.title') }) }), _jsx(Box, { maxWidth: "738px", marginHorizontal: "auto", whiteSpace: 'pre-line', children: items.map((item) => (_jsx(Accordion, { titleSize: "16", variant: "divided", title: item.title, content: item.content }, item.title))) }), _jsx(Box, { textAlign: "center", children: _jsx(Button, { variant: "primary", icon: ExternalLinkIcon, iconPosition: "end", onPress: () => redirectTo('https://www.nutzungsdauer.com/ausfuell-service/'), marginTop: "spacing.24", children: t(`fsrbo.${name}.faq.button`) }) })] }));
};
